import React, { HTMLAttributeAnchorTarget } from 'react'
import { LoadingIcon } from 'components/icons'
import PropertyCard from './PropertyCard'
import { Property } from 'gql/graphql'

type PropTypes = {
  properties: Property[]
  isLoading: boolean
  isGraphQL: boolean
  target: HTMLAttributeAnchorTarget
}

const PropertyGridDisplay = ({
  properties = [],
  isLoading = false,
  isGraphQL = true,
  target = '_self',
}: PropTypes) => {
  return (
    <>
      {properties.length
        ? <div className="grid w-full grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-25 gap-y-60">
          {properties.map(property => (
            <PropertyCard
              property={property}
              target={target}
              isGraphQL={isGraphQL}
            />
          ))}
        </div>
        : <div className="mx-auto antialiased font-normal text-grey-750 w-max">
          {!isLoading && 'No properties found matching these criteria.'}
        </div>
      }
      {
        isLoading
        && <div className="flex justify-center mx-auto pt-50">
          <LoadingIcon />
        </div>
      }
    </>
  )
}

export default PropertyGridDisplay
